import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import HealthIntervals from 'redux/HealthIntervals';
import ReadingsHelpers from 'utils/ReadingsHelpers';
import Notifications from 'redux/Notifications';

const useHealthIntervals = () => {
  const dispatch = useDispatch();
  const fetchingHealthIntervals = useSelector(HealthIntervals.getIsFetchingHealthIntervals);
  const cropErrors = useSelector(HealthIntervals.getErrors);
  const healthIntervals = useSelector(HealthIntervals.getHealthIntervals);
  const suggestions = useSelector(HealthIntervals.getSuggestions);

  const getIntervalForReadingAtDepth = (telemetryType, depth) => {
    const intervals = _.find(healthIntervals, {
      depth: depth * 6,
      telemetry_type: telemetryType,
      crop_id: '00000000-0000-0000-0000-000000000000',
    });

    return intervals;
  };

  const getStatusForValue = (interval, value) => {
    let returnBound = 0;
    let returnStatus = 'default';

    if (interval) {
      if (value <= interval.lower_critical) {
        returnStatus = ReadingsHelpers.ReadingStatusStrings.LowCrit;
        returnBound = 0;
      } else if (value > interval.lower_critical && value <= interval.lower_warn) {
        returnStatus = ReadingsHelpers.ReadingStatusStrings.LowWarn;
        returnBound = 1;
      } else if (value > interval.lower_warn && value <= interval.normal_low) {
        returnStatus = ReadingsHelpers.ReadingStatusStrings.LowNormal;
        returnBound = 2;
      } else if (value > interval.normal_low && value <= interval.normal_high) {
        returnStatus = ReadingsHelpers.ReadingStatusStrings.Normal;
        returnBound = 3;
      } else if (value > interval.normal_high && value <= interval.upper_warn) {
        returnStatus = ReadingsHelpers.ReadingStatusStrings.HighNormal;
        returnBound = 4;
      } else if (value > interval.upper_warn && value <= interval.upper_critical) {
        returnStatus = ReadingsHelpers.ReadingStatusStrings.HighWarn;
        returnBound = 5;
      } else if (value > interval.upper_critical) {
        returnStatus = ReadingsHelpers.ReadingStatusStrings.HighCrit;
        returnBound = 6;
      }
    }

    return { status: returnStatus, interval, bound: returnBound };
  };

  const requestHealthIntervals = () => {
    if (!healthIntervals || healthIntervals?.length === 0) {
      dispatch(HealthIntervals.startFetchHealthIntervals());
      return dispatch(HealthIntervals.fetchHealthIntervals()).catch((err) => {
        dispatch(Notifications.setError(err));
      });
    }
  };

  const fetchSuggestionsForInterval = (interval) => {
    return dispatch(
      HealthIntervals.fetchSuggestions({
        health_interval_id: interval.id,
      })
    ).catch((err) => {
      dispatch(Notifications.setError(err));
    });
  };

  const requestSuggestions = (params) => {
    if (!fetchingHealthIntervals) {
      return dispatch(HealthIntervals.fetchSuggestions(params)).catch((err) => {
        dispatch(Notifications.setError(err));
      });
    }
  };

  const getSuggestionForInterval = (interval, foundBound) => {
    if (interval) {
      return _.find(suggestions, { health_interval_id: interval.id, bound: foundBound });
    }
    return '';
  };

  return {
    fetchingHealthIntervals,
    cropErrors,
    requestHealthIntervals,
    healthIntervals,
    getStatusForValue,
    getSuggestionForInterval,
    fetchSuggestionsForInterval,
    requestSuggestions,
    getIntervalForReadingAtDepth,
  };
};

export default useHealthIntervals;
